"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2171],{

/***/ 72171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33616);
var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgMetro = function SvgMetro(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fill: "CurrentColor",
    d: "m6.094 8.05-.487-.545a2.273 2.273 0 0 0 1.546-2.32l-.192-2.883A2.305 2.305 0 0 0 4.658 0H2.503A2.3 2.3 0 0 0 .201 2.285l-.195 2.9a2.273 2.273 0 0 0 1.548 2.32l-.487.543-.632.705a.26.26 0 1 0 .387.347l.546-.607h4.426l.546.607a.26.26 0 1 0 .387-.347l-.633-.703ZM1.003 6.556A1.764 1.764 0 0 1 .526 5.22l.195-2.918A1.784 1.784 0 0 1 2.503.52h2.155a1.789 1.789 0 0 1 1.783 1.8l.194 2.9a1.782 1.782 0 0 1-1.777 1.9H2.305a1.764 1.764 0 0 1-1.302-.564Zm.832 1.417.312-.346c.053.003.104.016.158.016h2.552c.054 0 .106-.013.159-.016l.312.346H1.835Zm.385-3.241h2.722a.942.942 0 0 0 .941-.94v-.683a.942.942 0 0 0-.94-.94H2.22a.942.942 0 0 0-.941.94v.681a.942.942 0 0 0 .94.941ZM1.8 3.109a.421.421 0 0 1 .42-.42h2.723a.421.421 0 0 1 .42.42v.681a.421.421 0 0 1-.42.421H2.22a.422.422 0 0 1-.421-.42v-.682Zm.524 2.67a.433.433 0 1 1-.867 0 .433.433 0 0 1 .867 0Zm3.377 0a.433.433 0 1 1-.125-.308.434.434 0 0 1 .128.307h-.003Zm-3.135-4.43a.26.26 0 0 1 .26-.26h1.509a.26.26 0 1 1 0 .52H2.826a.26.26 0 0 1-.26-.26Z"
  })));
};
/* harmony default export */ __webpack_exports__["default"] = (SvgMetro);

/***/ })

}]);